import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { Text } from '~/shared/components/Text/Text';
import { Grid } from '~/shared/components/Grid/Grid';
import { mq } from '~/lib';
import { breakpointsRaw } from '~/theme/breakpoints';

export const StyledGiftCardWrapper = styled.div(() => ({
    position: 'relative',
    width: '100%',
}));

export const StyledGiftCardContainer = styled(motion.div)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginTop: theme.space[7],
}));

export const StyledGiftCardStatusContainer = styled(motion.div)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
}));

export const StyledGiftCardBalancePageHeading = styled.div(({ theme }) => ({
    textTransform: 'uppercase',
    fontSize: '25px',
    lineHeight: '30px',
    marginBottom: '16px',
    color: theme.colors.black,
    fontWeight: theme.fontWeights.medium,
}));

export const StyledGiftCardBalancePageDescription = styled.div(() => ({
    [`p`]: {
        fontSize: '14px',
    },
}));

export const ErrorMessage = styled(Text)(({ theme }) => ({
    ...theme.mixins.useTextStyle('bodySmall'),
    color: theme.colors.negative,
}));

export const StyledGrid = styled(Grid)(() => ({
    [mq(0, breakpointsRaw.md)]: {
        gridTemplateColumns: '1fr',
    },
}));
